"use client";

import { SimulationSocketProvider } from "@/contexts/SimulationSocketContext";
import {
  TradeSocketContextProvider,
  TradeSocketProvider,
} from "@/contexts/TradeSocketContext";

export default function Layout({ children }: { children: React.ReactNode }) {
  return (
    <TradeSocketProvider>
      <TradeSocketContextProvider>
        <SimulationSocketProvider>{children}</SimulationSocketProvider>
      </TradeSocketContextProvider>
    </TradeSocketProvider>
  );
}
